export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./domain-transform-tabs.vue?vue&type=template&id=6bfd4e5e"


//////////////////
// WEBPACK FOOTER
// ./src/components/domain-transform-tabs.vue?vue&type=template&id=6bfd4e5e
// module id = 429
// module chunks = 0